import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Hero slider images and text
  const slides = [
    {
      image: '/hero-slide-1.png',
      title: 'Shaping the',
      subtitle: 'Future of Design'
    },
    {
      image: '/hero-slide-2.png',
      title: 'we design',
      subtitle: 'the future'
    },
    {
      image: '/hero-slide-3.png',
      title: 'Shaping the',
      subtitle: 'Future of Design'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="hero-arch04">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentSlide}
          className="hero-arch04-slide"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.2, ease: 'easeInOut' }}
        >
          <div 
            className="hero-arch04-bg"
            style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
          />
          <div className="hero-arch04-overlay" />
          
          <div className="hero-arch04-content">
            <motion.div 
              className="hero-arch04-text"
              initial={{ opacity: 0, y: 60 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <h1 className="hero-arch04-title">
                <span className="title-line">{slides[currentSlide].title}</span>
                <span className="title-line accent">{slides[currentSlide].subtitle}</span>
              </h1>
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.8 }}
              >
                <Link to="/services" className="hero-arch04-btn">
                  <span>Learn more</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Link>
              </motion.div>
            </motion.div>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Slide Navigation */}
      <div className="hero-arch04-nav">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`nav-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          >
            <span className="dot-inner" />
            <svg className="dot-progress" viewBox="0 0 36 36">
              <circle cx="18" cy="18" r="16" />
            </svg>
          </button>
        ))}
      </div>

      {/* Slide Counter */}
      <div className="hero-arch04-counter">
        <span className="current">{String(currentSlide + 1).padStart(2, '0')}</span>
        <span className="divider">/</span>
        <span className="total">{String(slides.length).padStart(2, '0')}</span>
      </div>

      {/* Scroll Indicator */}
      <motion.div 
        className="hero-arch04-scroll"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
      >
        <span>Scroll</span>
        <div className="scroll-line">
          <motion.div 
            className="scroll-dot"
            animate={{ y: [0, 20, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
